import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import heroBg from '../assets/images/HeroBanner.png';
import { useNavigate } from 'react-router-dom';
import '../styles/Branches.css';

const Branches = () => {
  const navigate = useNavigate();
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));

  const handleMemberLogin = () => {
    navigate('/member-login');
  };

  const handleEdcclogin = () => { 
    navigate('/edcc-login');
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState){
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // Fetch branches from backend
  const fetchBranches = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/getAllBranchesCMS`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      console.log('API Response:', result);
      
      // Access the data array from the response
      if (result.success && result.data && Array.isArray(result.data)) {
        // Filter only active branches that are not deleted
        const activeBranches = result.data.filter(branch => branch.status === 1 && !branch.isDeleted);
        setBranches(activeBranches);
        console.log('Active branches:', activeBranches);
      } else {
        console.error('Invalid response structure:', result);
        setError('Invalid data format received from server');
      }
    } catch (err) {
      console.error('Error fetching branches:', err);
      setError(`Failed to load branches: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
              {!tokenState && (
                <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
              )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="branch-section">
            <Container fluid>
              <h2 className="branch-heading">AIOTA Branches</h2>
              
              {loading && (
                <Row className="g-3 mb-4">
                  <Col xs={12}>
                    <div className="text-center text-light">
                      <h3>Loading branches...</h3>
                    </div>
                  </Col>
                </Row>
              )}

              {error && (
                <Row className="g-3 mb-4">
                  <Col xs={12}>
                    <div className="text-center text-dark">
                      <h3>Error: {error}</h3>
                      <Button 
                        className=" mt-3" 
                        onClick={fetchBranches}
                      >
                        Retry
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}

              {!loading && !error && branches.length === 0 && (
                <Row className="g-3 mb-4">
                  <Col xs={12}>
                    <div className="text-center text-light">
                      <h3>No branches found</h3>
                    </div>
                  </Col>
                </Row>
              )}

              {!loading && !error && branches.length > 0 && (
                <>
                  <Row className="g-3 mb-4">
                    {branches.slice(0, 3).map((branch) => (
                      <Col xs={12} md={4} key={branch._id}>
                        <Card className="h-100 text-center text-light branch-card">
                          <Card.Body>
                            <Card.Title className="mb-4 branch-card-title poppins-medium">
                              {branch.place?.toUpperCase()} BRANCH OF AIOTA
                            </Card.Title>
                            <Card.Subtitle className="mb-3 branch-card-subtitle poppins-medium">
                              Convenor: {branch.convenor}
                            </Card.Subtitle>
                            <Card.Text className="branch-card-address px-3">
                              <strong className="branch-card-bold">Address:</strong> {branch.address}
                            </Card.Text>
                       <Card.Text className="branch-card-mobile">
  <strong className="branch-card-bold">Mobile:</strong> {branch.phone_number}
</Card.Text>
                            <Card.Text className="branch-card-email">
                              <strong className="branch-card-bold">Email:</strong> {branch.email}
                            </Card.Text>
                            {branch.website && (
                              <Card.Text className="branch-card-website">
                                <strong className="branch-card-bold">Website:</strong>{' '}
                                <a 
                                  href={branch.website} 
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  style={{ color: 'inherit', textDecoration: 'underline' }}
                                >
                                  Visit Website
                                </a>
                              </Card.Text>
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                  
                  {branches.length > 3 && (
                    <Row className="g-3 mb-4">
                      {branches.slice(3, 6).map((branch) => (
                        <Col xs={12} md={4} key={branch._id}>
                          <Card className="h-100 text-center text-light branch-card">
                            <Card.Body>
                              <Card.Title className="mb-4 branch-card-title poppins-medium">
                                {branch.place?.toUpperCase()} BRANCH OF AIOTA
                              </Card.Title>
                              <Card.Subtitle className="mb-3 branch-card-subtitle poppins-medium">
                                Convenor: {branch.convenor}
                              </Card.Subtitle>
                              <Card.Text className="branch-card-address px-3">
                                <strong className="branch-card-bold">Address:</strong> {branch.address}
                              </Card.Text>
                              <Card.Text className="branch-card-mobile">
                                <strong className="branch-card-bold">Mobile:</strong> {branch.phone_number}
                              </Card.Text>
                              <Card.Text className="branch-card-email">
                                <strong className="branch-card-bold">Email:</strong> {branch.email}
                              </Card.Text>
                              {branch.website && (
                                <Card.Text className="branch-card-website">
                                  <strong className="branch-card-bold">Website:</strong>{' '}
                                  <a 
                                    href={branch.website} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ color: 'inherit', textDecoration: 'underline' }}
                                  >
                                    Visit Website
                                  </a>
                                </Card.Text>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  )}
                  
                  {branches.length > 6 && (
                    <Row className="g-3 mb-4">
                      {branches.slice(6, 9).map((branch) => (
                        <Col xs={12} md={4} key={branch._id}>
                          <Card className="h-100 text-center text-light branch-card">
                            <Card.Body>
                              <Card.Title className="mb-4 branch-card-title poppins-medium">
                                {branch.place?.toUpperCase()} BRANCH OF AIOTA
                              </Card.Title>
                              <Card.Subtitle className="mb-3 branch-card-subtitle poppins-medium">
                                Convenor: {branch.convenor}
                              </Card.Subtitle>
                              <Card.Text className="branch-card-address px-3">
                                <strong className="branch-card-bold">Address:</strong> {branch.address}
                              </Card.Text>
                             {branch.phone_number && (
  <Card.Text className="branch-card-mobile">
    <strong className="branch-card-bold">Mobile:</strong> {branch.phone_number}
  </Card.Text>
)}
                              <Card.Text className="branch-card-email">
                                <strong className="branch-card-bold">Email:</strong> {branch.email}
                              </Card.Text>
                              {branch.website && (
                                <Card.Text className="branch-card-website">
                                  <strong className="branch-card-bold">Website:</strong>{' '}
                                  <a 
                                    href={branch.website} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ color: 'inherit', textDecoration: 'underline' }}
                                  >
                                    Visit Website
                                  </a>
                                </Card.Text>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  )}
                  
                  {branches.length > 9 && (
                    <Row className="g-3 mb-4">
                      {branches.slice(9).map((branch) => (
                        <Col xs={12} md={4} key={branch._id}>
                          <Card className="h-100 text-center text-light branch-card">
                            <Card.Body>
                              <Card.Title className="mb-4 branch-card-title poppins-medium">
                                {branch.place?.toUpperCase()} BRANCH OF AIOTA
                              </Card.Title>
                              <Card.Subtitle className="mb-3 branch-card-subtitle poppins-medium">
                                Convenor: {branch.convenor}
                              </Card.Subtitle>
                              <Card.Text className="branch-card-address px-3">
                                <strong className="branch-card-bold">Address:</strong> {branch.address}
                              </Card.Text>
                              <Card.Text className="branch-card-mobile">
                                <strong className="branch-card-bold">Mobile:</strong> {branch.phone_number}
                              </Card.Text>
                              <Card.Text className="branch-card-email">
                                <strong className="branch-card-bold">Email:</strong> {branch.email}
                              </Card.Text>
                              {branch.website && (
                                <Card.Text className="branch-card-website">
                                  <strong className="branch-card-bold">Website:</strong>{' '}
                                  <a 
                                    href={branch.website} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ color: 'inherit', textDecoration: 'underline' }}
                                  >
                                    Visit Website
                                  </a>
                                </Card.Text>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  )}
                </>
              )}
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default Branches;